/* eslint-disable react/prop-types */
// src/components/printer/PrinterCard.jsx
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { Printer, Receipt, ChefHat, Wine, X } from "lucide-react";

const ConfigOption = ({ icon: Icon, label, checked = false, onChange }) => (
  <div className="flex items-center justify-between mb-4">
    <div className="flex items-center space-x-2">
      <Icon className="h-4 w-4 text-orange-600" />
      <span>{label}</span>
    </div>
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="form-checkbox h-4 w-4 text-orange-500 rounded border-gray-300 
                 focus:ring-orange-500 cursor-pointer transition-colors"
    />
  </div>
);

const PrinterCard = ({
  printer,
  onRemove,
  onConfigChange,
  onTestPrint,
  onPrintDailyReport,
}) => {
  if (!printer) return null;

  // Aseguramos que config tenga valores por defecto
  const defaultConfig = {
    printKitchenOrders: false,
    printBarOrders: false,
    autoCustomerBills: false,
  };

  const config = { ...defaultConfig, ...(printer.config || {}) };

  const handleConfigChange = (setting) => {
    if (onConfigChange) {
      onConfigChange(printer.id, setting);
    }
  };

  return (
    <Card className="border-orange-200">
      <CardHeader className="bg-orange-100">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center">
            <Printer className="h-5 w-5 mr-2 text-orange-600" />
            {printer.name || "Impresora sin nombre"}
          </CardTitle>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onRemove?.(printer.id)}
            className="text-gray-500 hover:text-red-600"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>

      <CardContent className="space-y-4 pt-4">
        <div className="space-y-2">
          <ConfigOption
            icon={ChefHat}
            label="Órdenes de Cocina"
            checked={config.printKitchenOrders}
            onChange={() => handleConfigChange("printKitchenOrders")}
          />

          <ConfigOption
            icon={Wine}
            label="Órdenes de Barra"
            checked={config.printBarOrders}
            onChange={() => handleConfigChange("printBarOrders")}
          />

          <ConfigOption
            icon={Receipt}
            label="Tickets de Cliente"
            checked={config.autoCustomerBills}
            onChange={() => handleConfigChange("autoCustomerBills")}
          />
        </div>

        <div className="pt-4 border-t border-orange-200">
          <Button
            onClick={() => onTestPrint?.(printer.id)}
            variant="outline"
            className="w-full bg-white hover:bg-orange-50"
          >
            <Printer className="mr-2 h-4 w-4" />
            Imprimir Prueba
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrinterCard;
